import http from '@/http/service'
 


export default function Parceiros(params={}){

    return http.get("/admin/parceiros",{ params })

}